import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { DropdownModule } from "primeng/dropdown";

import { SectionComponent } from "./section/section.component";

import { ViewSectionComponent } from "./view-section/view-section.component";
import { DataService_ViewSection } from "./view-section/shared/data.service";
import { SectionSelectorComponent } from "./view-section/section-selector/section-selector.component";
import { SectionDetailsComponent } from "./view-section/section-details/section-details.component";
import { StudentDetailsComponent } from "./view-section/student-details/student-details.component";

import { ClassroomAdminComponent } from "./classroom-admin/classroom-admin.component";
import { DataService_ClassroomAdmin } from "./classroom-admin/shared/data.service";
import { CourseSelectorComponent } from "./classroom-admin/course-selector/course-selector.component";
import { ClassAttendanceMenuComponent } from "./classroom-admin/class-attendance-menu/class-attendance-menu.component";

import { ClassAttendanceVerificationComponent } from "./class-attendance-verification/class-attendance-verification.component";
import { DataService_ClassAttendanceVerification } from "./class-attendance-verification/shared/data.service";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

@NgModule({
	declarations: [
		SectionComponent,
		ViewSectionComponent,
		SectionSelectorComponent,
		SectionDetailsComponent,
		StudentDetailsComponent,
		ClassroomAdminComponent,
		ClassAttendanceVerificationComponent,
		CourseSelectorComponent,
		ClassAttendanceMenuComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		PersonSelectorModule,
		TableModule,
		DropdownModule,
		SchoolselectorModule,
	],
	providers: [DataService_ViewSection, DataService_ClassroomAdmin, DataService_ClassAttendanceVerification],
})
export class SectionModule {}
